import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const TechnologiesComponent = ({ title, icon, skills }) => {
    return <div>
        <div className="text-left font-bold text-3xl flex items-center mb-8 mt-8">
            <div className="mr-4 bg-primary w-10 h-10 flex justify-center items-center rounded-3xl">
                <FontAwesomeIcon icon={icon} color="#FFF" size="xs"/>
            </div>
            <div className="text-primary">
                {title}
            </div>
        </div>
        <div className="flex flex-wrap justify-center mb-8">
            {skills.map(skill => {
                return <div key={skill} className="py-1 px-2 m-1 text-gray-400 border-gray-400 rounded-md border">
                    {skill}
                </div>
            })}
        </div>
    </div>
}
